import React, { useState } from "react";
import { useField } from "formik";
import { Form, Button, Modal, Image } from "react-bootstrap";

const FileInput = ({
  label,
  name,
  setPhoto,
  photoPreview,
  clearPhotoPreview,
  accept = "image/*",
}) => {
  const [field, meta, helpers] = useField(name);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof setPhoto === "function") {
          setPhoto(reader.result);
        }
        helpers.setValue(file); // Setting the file in Formik's state
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClearPreview = () => {
    if (typeof setPhoto === "function") {
      setPhoto(null); // Clear the photo preview
    }
    helpers.setValue(null); // Reset Formik's value
    if (clearPhotoPreview) {
      clearPhotoPreview(); // Call optional external handler
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <Form.Group className="mb-3 mt-2" controlId={name}>
      <Form.Label className="text-dark">{label}:</Form.Label>
      <div className="">
        <Form.Control
          type="file"
          accept={accept}
          onChange={handlePhotoChange}
          isInvalid={meta.touched && meta.error}
        />
        {meta.touched && meta.error && (
          <Form.Control.Feedback type="invalid">
            {meta.error}
          </Form.Control.Feedback>
        )}

        {photoPreview && (
          <div className="mt-3 position-relative">
            <div
              className="position-relative d-inline-block border rounded"
              style={{ overflow: "hidden", width: "160px", height: "170px" }}
            >
              <Image
                src={photoPreview}
                alt={`${label} Preview`}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                onClick={toggleModal}
                rounded
              />
              <Button
                variant="danger"
                size="sm"
                onClick={handleClearPreview}
                className="position-absolute"
                style={{
                  top: "5px",
                  right: "5px",
                  borderRadius: "50%",
                  padding: "0 6px",
                }}
              >
                &times;
              </Button>
            </div>
          </div>
        )}
      </div>

      {/* Modal for full-size preview */}
      <Modal show={isModalOpen} onHide={toggleModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{label} Full View</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image
            src={photoPreview}
            alt={`${label} Full View`}
            fluid
            style={{ objectFit: "contain" }}
          />
        </Modal.Body>
      </Modal>
    </Form.Group>
  );
};

export default FileInput;
